export const decimalToPercentage = (decimal: number) => `${(decimal * 100).toFixed(0)}%`;
